import React, { Component } from 'react'
import { connect } from 'react-redux'
import classes from './QuizCreator.css'
import { createControl, validate, validateForm } from '../../form/formFramework'
import {
  createQuizQuestion,
  finishCreateQuiz
} from '../../store/actions/create'
import Input from '../../components/UI/Input/Input'
import Button from '../../components/UI/Button/Button'
import Select from '../../components/UI/Select/Select'

class QuizCreator extends Component {
  state = {
    isFormValid: false,
    rightAnswerId: 1,
    formControls: this.createFormControls()
  }

  createOptionControl(num) {
    return createControl(
      {
        label: `Вариант #${num}`,
        errorMessage: 'Поле не может быть пустым',
        id: num
      },
      { required: true }
    )
  }

  createFormControls() {
    return {
      question: createControl(
        {
          label: 'Введите вопрос',
          errorMessage: 'Вопрос не может быть пустым'
        },
        { required: true }
      ),
      option1: this.createOptionControl(1),
      option2: this.createOptionControl(2),
      option3: this.createOptionControl(3),
      option4: this.createOptionControl(4)
    }
  }

  submitHandler = e => {
    e.preventDefault()
  }

  addQuestionHandler = e => {
    e.preventDefault()

    const {
      question,
      option1,
      option2,
      option3,
      option4
    } = this.state.formControls

    const questionItem = {
      question: question.value,
      id: this.props.quiz.length + 1,
      rightAnswerId: this.state.rightAnswerId,
      answers: [
        { text: option1.value, id: option1.id },
        { text: option2.value, id: option2.id },
        { text: option3.value, id: option3.id },
        { text: option4.value, id: option4.id }
      ]
    }

    this.props.createQuizQuestion(questionItem)

    this.setState({
      isFormValid: false,
      rightAnswerId: 1,
      formControls: this.createFormControls()
    })
  }

  createQuizHandler = e => {
    e.preventDefault()

    this.setState({
      isFormValid: false,
      rightAnswerId: 1,
      formControls: this.createFormControls()
    })

    this.props.finishCreateQuiz()
  }

  changeHandler(value, controlName) {
    const formControls = { ...this.state.formControls }
    const control = { ...formControls[controlName] }

    control.touched = true
    control.value = value
    control.valid = validate(control.value, control.validation)

    formControls[controlName] = control

    this.setState({
      formControls,
      isFormValid: validateForm(formControls)
    })
  }

  renderControls() {
    return Object.keys(this.state.formControls).map((controlName, index) => {
      const control = this.state.formControls[controlName]

      return (
        <React.Fragment key={controlName + index}>
          <Input
            label={control.label}
            value={control.value}
            valid={control.valid}
            shouldValidate={!!control.validation}
            touched={control.touched}
            errorMessage={control.errorMessage}
            onChange={e => this.changeHandler(e.target.value, controlName)}
          />
        </React.Fragment>
      )
    })
  }

  selectChangeHandler = e => {
    this.setState({
      rightAnswerId: +e.target.value
    })
  }

  render() {
    const select = (
      <Select
        label='Выберите правильный ответ'
        value={this.state.rightAnswerId}
        onChange={this.selectChangeHandler}
        options={[
          { text: 1, value: 1 },
          { text: 2, value: 2 },
          { text: 3, value: 3 },
          { text: 4, value: 4 }
        ]}
      />
    )
    return (
      <div className={classes.QuizCreator}>
        <div>
          <h1>Создание теста</h1>

          <hr />

          <form onSubmit={this.submitHandler}>
            {this.renderControls()}

            {select}

            <Button
              type='primary'
              onClick={this.addQuestionHandler}
              disabled={!this.state.isFormValid}
            >
              Добавить вопрос
            </Button>
            <Button
              type='success'
              onClick={this.createQuizHandler}
              disabled={this.props.quiz.length === 0}
            >
              Создать тест
            </Button>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    quiz: state.create.quiz
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createQuizQuestion: item => dispatch(createQuizQuestion(item)),
    finishCreateQuiz: () => dispatch(finishCreateQuiz())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizCreator)
